import { useAppSelector } from "../../store";

const Footer = () => {
  const { data: siteData } = useAppSelector((state) => state.siteData);

  return (
    <header
      dangerouslySetInnerHTML={{
        __html: siteData?.ssrHtml?.footer,
      }}
    ></header>
  );
};
export default Footer;
